import { useEffect } from 'react';
import { useParams, Navigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

/**
 * Wrapper de route publique avec préfixe de langue (/fr/... ou /en/...).
 *
 * - Lit le param :lang de l'URL (route définie comme path="/:lang/..." dans App.jsx)
 * - Si lang invalide → redirige vers /fr<rest_of_path>
 * - Sinon : synchronise LanguageContext avec la lang de l'URL et render children
 *
 * L'URL devient la source de vérité pour la langue sur les pages publiques.
 * (Le dashboard reste en dehors de ce wrapper — langue gérée par profil user.)
 */
export default function PublicLangRoute({ children }) {
    const { lang } = useParams();
    const location = useLocation();
    const { language, setLanguage } = useLanguage();

    // Garde-fou : lang invalide (ex. /xx/about) → redirige vers /fr
    const isValidLang = lang === 'fr' || lang === 'en';

    useEffect(() => {
        if (isValidLang && lang !== language) {
            setLanguage(lang);
        }
    }, [lang, language, isValidLang, setLanguage]);

    if (!isValidLang) {
        // Remplace le premier segment par /fr (ex. /xx/about → /fr/about)
        const fixed = location.pathname.replace(/^\/[^/]+/, '/fr');
        return <Navigate to={fixed + location.search + location.hash} replace />;
    }

    return children;
}
